import { FilterValue } from "../Filters/FilterValue";

export const ProjectPaymentStatus: FilterValue[] = [
  { id: "0", value: "" },
  { id: "1", value: "Paid" },
  { id: "2", value: "Pending" },
  { id: "3", value: "Partial" },
  { id: "4", value: "Purchase Order" },
];
